import { render } from "./EventWaiver.vue?vue&type=template&id=67ccf2a0&scoped=true"
const script = {}

import "./EventWaiver.vue?vue&type=style&index=0&id=67ccf2a0&scoped=true&lang=scss"

import exportComponent from "c:\\DevOpsProdCore2_02\\_work\\161\\s\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ccf2a0"]])

export default __exports__